import { z } from 'zod';
import { ErrorResponseSchema } from '../../common/base';

/**
 * Request schema for checking email availability
 * POST /api/user/check-email
 */
export const CheckEmailRequestSchema = z.object({
  /** Email address to check */
  email: z.string().email('Invalid email format'),
});

export type CheckEmailRequest = z.infer<typeof CheckEmailRequestSchema>;

/**
 * Success response schema for email check
 */
const CheckEmailSuccessSchema = z.object({
  success: z.literal(true),
  /** Whether the email is already registered */
  exists: z.boolean(),
  /** Whether the email is available for registration */
  available: z.boolean(),
});

export type CheckEmailSuccess = z.infer<typeof CheckEmailSuccessSchema>;

/**
 * Combined response schema for check-email endpoint
 * Discriminated union based on success field
 *
 * @example
 * ```typescript
 * const response = CheckEmailResponseSchema.parse(data);
 * if (response.success) {
 *   if (response.available) {
 *     console.log('Email is available');
 *   } else {
 *     console.log('Email is already registered');
 *   }
 * }
 * ```
 */
export const CheckEmailResponseSchema = z.discriminatedUnion('success', [
  CheckEmailSuccessSchema,
  ErrorResponseSchema,
]);

export type CheckEmailResponse = z.infer<typeof CheckEmailResponseSchema>;
